import { render } from "./AllMetricList.vue?vue&type=template&id=22cab5fa"
import script from "./AllMetricList.vue?vue&type=script&lang=js"
export * from "./AllMetricList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__